/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
    selector: '[appUrlValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: UrlValidationDirective, multi: true }]
})

/**
 * @name UrlValidationDirective
 */
export class UrlValidationDirective implements Validator {
    public validate(control: AbstractControl): { [key: string]: any } | null {
        return urlValidation(control);
    }
}

/**
 * URL validation.
 * @param control
 * @returns {any}
 */
export function urlValidation(control: any): any {
    let url: URL;

    try {
        url = new URL(control.value);
    } catch (_) {
        url = null;
    }

    return (url?.protocol === 'http:' || url?.protocol === 'https:') ? null : { 'urlValidation': 'url_validation' };
}
